import { gql } from "graphql-request";

export const CREATE_CHAT_MUTATION = gql`
  mutation CreateChat($input: ChatCreateInput!) {
    createChat(input: $input) {
      data {
        _id
        title
        category
        createdAt
      }
    }
  }
`;

export const GET_CHATS_QUERY = gql`
  query GetChats($filter: ChatFilterInput) {
    chats(filter: $filter) {
      data {
        _id
        title
        category
        totalMessages
        lastActivityAt
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_CHAT_QUERY = gql`
  query GetChat($id: ID!) {
    chat(id: $id) {
      data {
        _id
        title
        category
        context
        firstMessageAt
        messages {
          _id
          content
          source
          messageOrder
          attachmentIds
          createdAt
          llmMetadata {
            model
            confidence
            mcpToolsUsed
            hasInternalData
            thinking
            processingSteps
            toolCalls {
              toolName
              name
              arguments
              args
              timestamp
              success
            }
          }
        }
      }
    }
  }
`;

export const SEND_MESSAGE_MUTATION = gql`
  mutation SendMessage($chatId: ID!, $input: ChatMessageInput!) {
    sendMessage(chatId: $chatId, input: $input) {
      data {
        _id
        title
        messages {
          _id
          content
          source
          messageOrder
          createdAt
          llmMetadata {
            model
            confidence
            mcpToolsUsed
            hasInternalData
          }
        }
      }
    }
  }
`;

export const SEND_MESSAGE_STREAMING_MUTATION = gql`
  mutation SendMessageStreaming($chatId: ID!, $input: StreamingChatMessageInput!) {
    sendMessageStreaming(chatId: $chatId, input: $input) {
      success
      chatId
      streamId
    }
  }
`;

export const CHAT_STREAM_SUBSCRIPTION = gql`
  subscription ChatStream($streamId: String!) {
    chatStream(streamId: $streamId) {
      type
      content
      metadata
      timestamp
      streamId
    }
  }
`;

export const UPDATE_CHAT_TITLE_MUTATION = gql`
  mutation UpdateChatTitle($id: ID!, $title: String!) {
    updateChat(id: $id, input: { title: $title }) {
      data {
        _id
        title
      }
    }
  }
`;

export const UPDATE_CHAT_CATEGORY_MUTATION = gql`
  mutation UpdateChatCategory($id: ID!, $category: ChatCategory!) {
    updateChat(id: $id, input: { category: $category }) {
      data {
        _id
        title
        category
      }
    }
  }
`;

export const DELETE_CHAT_MUTATION = gql`
  mutation DeleteChat($id: ID!) {
    deleteChat(id: $id) {
      data
    }
  }
`;

// Chat Attachment queries and mutations
export const GENERATE_CHAT_ATTACHMENT_SIGNED_URL = gql`
  query GenerateChatAttachmentUploadSignedUrl(
    $chatId: ID!
    $tenantId: ID
    $fileName: String!
    $contentType: String!
    $sizeBytes: Int!
  ) {
    generateChatAttachmentUploadSignedUrl(
      chatId: $chatId
      tenantId: $tenantId
      fileName: $fileName
      contentType: $contentType
      sizeBytes: $sizeBytes
    ) {
      signedUrl
      key
    }
  }
`;

export const CREATE_CHAT_ATTACHMENT = gql`
  mutation CreateChatAttachment($input: CreateChatAttachmentInput!) {
    createChatAttachment(input: $input) {
      data {
        _id
        chatId
        filename
        mimeType
        sizeBytes
        s3Key
        status
        error {
          code
          message
        }
        extractedText
        summary
        meta {
          pageCount
          rowCount
          colCount
          sheetCount
          width
          height
        }
        ingestedAt
        createdAt
      }
    }
  }
`;

export const GET_CHAT_ATTACHMENTS = gql`
  query ChatAttachments($chatId: ID!) {
    chatAttachments(chatId: $chatId) {
      data {
        _id
        chatId
        filename
        mimeType
        sizeBytes
        status
        error {
          code
          message
        }
        summary
        createdAt
      }
    }
  }
`;

export const GET_CHAT_ATTACHMENT = gql`
  query ChatAttachment($id: ID!) {
    chatAttachment(id: $id) {
      data {
        _id
        chatId
        filename
        mimeType
        sizeBytes
        s3Key
        status
        error {
          code
          message
        }
        extractedText
        summary
        meta {
          pageCount
          rowCount
          colCount
          sheetCount
          width
          height
        }
        ingestedAt
        createdAt
      }
    }
  }
`;

export const DELETE_CHAT_ATTACHMENT = gql`
  mutation DeleteChatAttachment($id: ID!) {
    deleteChatAttachment(id: $id) {
      success
    }
  }
`;

export const GENERATE_CHAT_ATTACHMENT_ACCESS_SIGNED_URL = gql`
  query GenerateChatAttachmentAccessSignedUrl($id: ID!) {
    generateChatAttachmentAccessSignedUrl(id: $id) {
      signedUrl
      key
    }
  }
`;

// Pending attachment mutations (for upload before chat exists)
export const GENERATE_PENDING_ATTACHMENT_SIGNED_URL = gql`
  query GeneratePendingAttachmentUploadSignedUrl(
    $sessionId: String!
    $tenantId: ID
    $fileName: String!
    $contentType: String!
    $sizeBytes: Int!
  ) {
    generatePendingAttachmentUploadSignedUrl(
      sessionId: $sessionId
      tenantId: $tenantId
      fileName: $fileName
      contentType: $contentType
      sizeBytes: $sizeBytes
    ) {
      signedUrl
      key
    }
  }
`;

export const CREATE_PENDING_ATTACHMENT = gql`
  mutation CreatePendingAttachment($input: CreatePendingAttachmentInput!) {
    createPendingAttachment(input: $input) {
      data {
        _id
        sessionId
        filename
        mimeType
        sizeBytes
        s3Key
        status
        error {
          code
          message
        }
        createdAt
      }
    }
  }
`;

export const ASSOCIATE_PENDING_ATTACHMENTS = gql`
  mutation AssociatePendingAttachments($chatId: ID!, $attachmentIds: [ID!]!) {
    associatePendingAttachments(chatId: $chatId, attachmentIds: $attachmentIds) {
      data {
        _id
        chatId
        filename
        mimeType
        sizeBytes
        status
        error {
          code
          message
        }
        createdAt
      }
    }
  }
`;
